import { render, staticRenderFns } from "./accidentPop.vue?vue&type=template&id=6f7d439e"
import script from "./accidentPop.vue?vue&type=script&lang=js"
export * from "./accidentPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f7d439e')) {
      api.createRecord('6f7d439e', component.options)
    } else {
      api.reload('6f7d439e', component.options)
    }
    module.hot.accept("./accidentPop.vue?vue&type=template&id=6f7d439e", function () {
      api.rerender('6f7d439e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/sop/iim/accidentPop.vue"
export default component.exports